module.exports = {
    APP_NAME: 'reader.gBible',
    API_URL: 'https://reader.gbible.net/api/v1',
    VUEX_KEY: 'READER.GBIBLE.VUEX',
    GOOGLE_ANALYTICS: 'G-JHZM7K615X',
    APP_LOCALE: 'ja',
    APP_BIBLE: 59,
}

